export default __webpack_public_path__ + "static/lingvo-portret-8825b7d686cb6c4c6499ee9a2abf6869.png";